<template>
  <div>emty page</div>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
